
export default {
  props: ["src", "class"],
  data() {
    return {
      showModal: false,
    };
  },
};
